<template>
  <div style="display: inline-block">
    <div v-if="type === 'input'">
      <el-input :placeholder="$t('message.placeholder.input')" v-model="value"
        :onkeyup="value = value.replace(/\s+/g, '')" size="small" class="common" clearable :disabled="!isOperator">
      </el-input>
    </div>
    <div v-if="type === 'mutiList'">
      <el-select v-model="value" multiple filterable :placeholder="$t('message.placeholder.select')" size="small"
        class="common" :disabled="!isOperator">
        <el-option v-for="item in selectList" :key="item.index" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div v-if="type === 'date'">
      <el-date-picker v-if="between" v-model="value" size="small" class="common" type="datetimerange"
        :start-placeholder="$t('message.placeholder.startDate')" :end-placeholder="$t('message.placeholder.endDate')"
        :default-time="['00:00:00']">
      </el-date-picker>
      <el-date-picker v-else v-model="value" type="datetime" size="small" class="common" :disabled="!isOperator"
        :placeholder="$t('message.placeholder.pickDate')">
      </el-date-picker>
    </div>

    <div v-if="type === 'money'">
      <div v-if="between" class="money">
        <!-- 11211 -->
        <el-input :placeholder="$t('message.placeholder.input')" v-model="value[0]" size="small" type="number"
          class="common-dbinput" style="width: 48%" :disabled="!isOperator">
        </el-input>
        -
        <el-input :placeholder="$t('message.placeholder.input')" v-model="value[1]" size="small" type="number"
          class="common-dbinput" :disabled="!isOperator">
        </el-input>
      </div>
      <el-input v-else :placeholder="$t('message.placeholder.input')" v-model="value" size="small" class="common"
        type="number" :disabled="!isOperator">
      </el-input>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      value: "",
      value2: "",
      type: "input",
      selectList: [],

      options: [],
      loading: false,
      states: ["Alabama", "Alaska", "Arizona"],

      typeList: [
        { label: "input", val: 1 },
        { label: "input", val: 2 },
        { label: "mutiList", val: 3 },
        { label: "mutiList", val: 4 },
        { label: "date", val: 6 },
        { label: "money", val: 7 },
        { label: "money", val: 10 },
      ],
      between: false,
      isOperator: false,
      disableList: ["", 9, 10],
    };
  },
  props: ["getList", "propData", "operatorType", "values", "loadedSearch"],
  computed: {},
  methods: {},
  watch: {
    propData(e) {
      // console.log(184444,e);
      this.value = "";
      this.type = this.typeList.find((i) => {
        return i.val == e[1];
      })?.label;
    },
    // uiType(e) {
    //   // this.type = e
    //   this.value = ''
    //   console.log(e);
    //   this.type = this.typeList.filter((i) => {
    //     return i.val == e;
    //   })[0].label;
    // },
    getList(e) {
      this.options = [];
      this.selectList = e;
      // console.log(this.selectList);
      if (!this.loadedSearch) {
        return
      }
      if (
        [13, 14, 15, 11].includes(this.operatorType)
      ) {
        let arr = [];
        console.log(this.values);
        if (this.values != null) {
          if (this.values.indexOf(";") != -1) {
            arr = this.values.split(";");
          } else {
            arr.push(this.values);
          }
        }
        // arr.push(Number(this.values));
        this.value = arr;
      }
      // else if (this.operatorType == 9 || this.operatorType == 10) {
      // } else if (this.operatorType == 16 || this.operatorType == 17) {
      // }
      else {
        this.value = this.values;
      }
      // console.log(this.value);
    },
    operatorType(e) {
      // this.value = ''
      this.isOperator = !this.disableList.includes(e);
      // if (this.disableList.indexOf(e) == -1 ) {
      //   this.isOperator = true;
      // } else {
      //   this.isOperator = false;
      // }
      if (e == 9 || e == 10 || e == "") {
        this.value = "";
      }
      console.log(e);
      const validNumbers = new Set([11, 13, 14, 15, 16, 17]);
      if (validNumbers.has(e)) {
        this.value = [];
        this.between = true;

        if (this.loadedSearch) {
          if (this.operatorType == 16 || this.operatorType == 17) {
            // this.value = [new   Date(Date.parse(this.values[0].replace(/-/g,   "/"))),new   Date(Date.parse(this.values[1].replace(/-/g,   "/")))];
            this.value = [new Date(this.values[0]), new Date(this.values[1])];
            this.between = true;
          }
        }
      } else {
        this.between = false;
      }
      // console.log(this.value);
    },
    value(e) {
      // console.log(e);
      if (e.length == 0) {
        this.$emit("change", {});
      }
      // console.log(e);
      let obj = {};
      obj.value = e;
      obj.secValue = "";
      if (this.type == "list" || this.type == "mutiList") {
        if (e.length == 0) {
          obj.value = "";
          obj.secValue = "";

          return;
        }
        let m = [...e];
        obj.value = m.join(";");
        obj.secValue = "";
      }
      if (this.between) {
        obj.value = e[0];
        obj.secValue = e[1];
      }
      // console.log(obj);
      // if(!e){
      //   console.log(1111);
      // }
      this.$emit("change", obj);
    },
  },
  created() {
    // console.log(this.type);
  },
};
</script>
<style scoped>
.common {
  width: 100%;
}

.common-dbinput {
  width: 47%;
}

.link {
  width: 6%;
  display: inline-block;
}

.money /deep/ .common-dbinput input::-webkit-outer-spin-button,
.money /deep/ .common-dbinput input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.money /deep/ .common-dbinput input[type="number"] {
  -moz-appearance: textfield;
}
</style>
